<script setup lang="ts">
import { onMounted, ref } from "vue";

import { usePopupManager } from "@/shared/composables/usePopupManager";
import { useMutationAttemptLogout } from "@/features/authentication/services/query/useMutationAttemptLogout";

import Button from "@/shared/components/button/Button.vue";

import type { AlertInvalidTokenErrorProps } from "@/features/authentication/model/interface";

const props = defineProps<AlertInvalidTokenErrorProps>();

const { attemptLogout, isPending } = useMutationAttemptLogout();
const { closePopup, clearPopup } = usePopupManager();

const time = ref<number>(10);
const interval = ref<NodeJS.Timeout>();

/**
 * @description
 * 로그아웃 버튼을 눌렀을 때의 이벤트 (타입아웃 clear)
 */
const clickConfirmButton = () => {
    clearInterval(interval.value);
    attemptLogout();
    clearPopup();
};

onMounted(async () => {
    // 10초 동안 카운트 시작
    await new Promise((resolve) => {
        interval.value = setInterval(() => {
            time.value -= 1;
            if (time.value === 0) {
                clearInterval(interval.value);
                resolve(true);
            }
        }, 1000);
    });

    // 이후 로그아웃 실행
    attemptLogout();
    clearPopup();
});
</script>

<template>
    <section class="flex flex-col justify-center items-center size-full">
        <div
            class="mb-[3.2rem] flex h-auto w-full flex-col items-center justify-center gap-[0.8rem]"
        >
            <p class="text-base font-semibold font-pretended text-primary-red">경고</p>
            <h2 class="font-semibold text-center whitespace-pre-wrap text-md text-primary-black">
                {{ rest.title }}
            </h2>
            <p class="text-base font-semibold font-pretended text-primary-gray">
                {{ time }}초 후 로그아웃됩니다.
            </p>
        </div>
        <div class="flex h-auto w-full min-w-[30rem] items-center justify-center gap-[1.2rem]">
            <Button
                :type="'button'"
                :color="'primary'"
                :value="'로그아웃'"
                :disabled="false"
                :is-width-full="true"
                :loading="isPending"
                @click="clickConfirmButton"
            />
        </div>
    </section>
</template>
